module.exports = __webpack_public_path__ + "img/level2addon_mining_hands.f6bfc1a5.png";